export default {"src":"/_next/static/media/functionality.cc867b09.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};